import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subdealer } from '../../../shared/interfaces/dealer.interfaces';

const basePath = '/dealer/children';

@Injectable({
  providedIn: 'root'
})

export class DealerChildrenService {
  constructor(private http: HttpClient) { }

  // Gets all children dealers (subdelers) of the current dealer
  getChildrenDealers(): Observable<Subdealer[] | []> {
    return this.http.get<Subdealer[]>(`${basePath}`);
  }
}
